import React from "react";
import { Link } from "gatsby";
import {
	MDBCard,
	MDBBadge,
	MDBContainer,
	MDBCol,
	MDBRow,
	MDBIcon,
} from "mdbreact";
import PropTypes from "prop-types";
import { GGgetMode } from "../../services/gglocalstorage";

import "./CardCurso.css";

export default function CardCurso({
	slug,
	name,
	image,
	opcoes,
	instituto,
	className = "",
	tagEventos,
}) {
	CardCurso.propTypes = {
		slug: PropTypes.string.isRequired,
		opcoes: PropTypes.node.isRequired,
		name: PropTypes.string.isRequired,
		instituto: PropTypes.string,
		image: PropTypes.string,
		className: PropTypes.string,
		tagEventos: PropTypes.string,
	};

	const urlCurso = `/cursos/${slug}/`;

	const nomeInstituto =
		instituto && instituto.length > 0
			? instituto[0].toUpperCase() + instituto.substring(1)
			: "";

	return (
		<Link to={urlCurso} className="card-curso-link">
			<MDBCard
				className={`${className} card-curso h-100 my-2 mx-2 ${
					GGgetMode() ? "card-curso--gg" : ""
				}`}
			>
				<div className="card-curso-tags mx-2 mt-3 text-center">
					{nomeInstituto && (
						<MDBBadge className="card-curso-tag card-curso-tag--destaque mx-1">
							<span>{nomeInstituto}</span>
						</MDBBadge>
					)}

					{tagEventos === "Novo" && (
						<MDBBadge className="card-curso-tag card-curso-tag--padrao mx-1">
							<span>✦ Novo</span>
						</MDBBadge>
					)}

					{opcoes?.map((opcao) => {
						const opcaoRenderizada = opcao.replace(
							/\bHíbrido\b/g,
							"Presencial"
						);

						return (
							<MDBBadge
								key={opcao}
								className="card-curso-tag card-curso-tag--padrao mx-1"
							>
								<span>{opcaoRenderizada}</span>
							</MDBBadge>
						);
					})}
				</div>

				<h4 className="card-curso-title text-center pt-4 my-auto pb-1">
					{name}
				</h4>

				<MDBContainer>
					<MDBRow>
						<MDBCol col={12}>
							<div className="card-curso-arrow mb-3 align-text-bottom text-right">
								<MDBIcon icon="arrow-right" size="2x" />
							</div>
						</MDBCol>
					</MDBRow>
				</MDBContainer>
			</MDBCard>
		</Link>
	);
}
